import React from "react";
import { Link, useMatch, useResolvedPath } from "react-router-dom";

function CustomLink({ children, to, ...props }) {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });

  return (
    <div>
      <Link
        style={{
          paddingBottom: "0px",
          margin: "10px",
          textTransform: "uppercase",
          color: match ? "#0000ff" : "#ccd6f6",
          textDecoration: "none",
          border: match ? "2px solid #0000ff" : "",
          padding: "7px 15px",
          borderRadius: "5px",
          backgroundColor: "transparent",
          boxShadow: "rgba(5, 33, 247, 0.32) 0px 2px 4px 0px",
        }}
        to={to}
        {...props}
      >
        {children}
      </Link>
    </div>
  );
}

export default CustomLink;
